<template>
  <div class="full-height-global">
    <modal-save v-show="getShowSaveModal" @goTo="goTo"></modal-save>
    <modal-pdf v-show="getShowPdfModal"></modal-pdf>
    <modal-project v-show="getShowProjectModal" :currentState="this.currentState"></modal-project>
    <landing v-show="currentState === 'landing'" :currentState="this.currentState" @goTo="goTo" ref="landing"></landing>
    <project v-show="currentState === 'project'" :currentState="this.currentState" @goTo="goTo" @goTo2="goTo2" ref="project"></project>
    <goals v-show="currentState === 'goals'" :currentState="this.currentState" @goTo="goTo" @goTo2="goTo2" ref="goals"></goals>
    <targets v-show="currentState === 'targets'" :currentState="this.currentState" @goTo="goTo" @goTo2="goTo2" ref="targets"></targets>
    <results v-show="currentState === 'results'" :currentState="this.currentState" @goTo="goTo" @goTo2="goTo2" ref="results"></results>
    <wheel ref="globalWheel" v-show="showGlobalWheel" :name="'global'"></wheel>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import landing from './../components/views/landing.vue'
import project from './../components/views/project.vue'
import goals from './../components/views/goals.vue'
import targets from './../components/views/targets.vue'
import results from './../components/views/results.vue'
import wheel from './../components/shared/sdg-wheel/sdg-wheel.vue'
import modalSave from './../components/shared/modal/modal-save.vue'
import modalPdf from './../components/shared/modal/modal-pdf.vue'
import modalProject from './../components/shared/modal/modal-project.vue'

export default {
  name: 'global',
  data () {
    return {
      showGlobalWheel: false,
      currentState: 'landing',
      states: [],
      transitions: [
        { fromState: 'landing', toState: 'project', animateWheel: true },
        { fromState: 'project', toState: 'goals', animateWheel: true },
        { fromState: 'goals', toState: 'targets', animateWheel: true },
        { fromState: 'goals', toState: 'results', animateWheel: false },
        { fromState: 'goals', toState: 'landing', animateWheel: false },
        { fromState: 'targets', toState: 'goals', animateWheel: false },
        { fromState: 'targets', toState: 'results', animateWheel: false },
        { fromState: 'targets', toState: 'landing', animateWheel: false },
        { fromState: 'results', toState: 'goals', animateWheel: false },
        { fromState: 'results', toState: 'targets', animateWheel: false },
        { fromState: 'results', toState: 'landing', animateWheel: false }
      ],
      transition: null,
      fromRect: null
    }
  },
  components: {
    landing,
    project,
    goals,
    targets,
    results,
    wheel,
    'modal-save': modalSave,
    'modal-pdf': modalPdf,
    'modal-project': modalProject
  },
  computed: {
    ...mapGetters({
      getWheelVisible: 'getWheelVisible',
      getShowPdfModal: 'getShowPdfModal',
      getShowSaveModal: 'getShowSaveModal',
      getShowProjectModal: 'getShowProjectModal'
    })
  },
  methods: {
    ...mapActions({
      setWheelVisible: 'setWheelVisible',
      setCurrentState: 'setCurrentState'
    }),
    goTo (goToState) {
      this.transition = this.transitions.find(transition => transition.fromState === this.currentState && transition.toState === goToState)

      if (this.transition) {
        let fromState = this.states.find(state => state.name === this.currentState)
        this.currentState = goToState

        this.setCurrentState(this.currentState)

        if (this.transition.animateWheel) {
          this.fromRect = this.getOffset(fromState.wheel.$el)
        }
      } else {
        throw new Error('transition undefined || null')
      }
    },
    goTo2 () {
      if (this.transition.animateWheel) {
        let toState = this.states.find(state => state.name === this.transition.toState)
        let toRect = this.getOffset(toState.wheel.$el)
        let fromCenter = { centerX: this.fromRect.x + (this.fromRect.width / 2), centerY: this.fromRect.y + (this.fromRect.height / 2) }
        let toCenter = { centerX: toRect.x + (toRect.width / 2), centerY: toRect.y + (toRect.height / 2) }
        this.showGlobalWheel = true
        this.setWheelVisible(false)
        this.$refs.globalWheel.$el.style.cssText = 'visibility: visible; z-index: 999999; position: absolute; top: ' + this.fromRect.top + 'px; left: ' + this.fromRect.left + 'px; width: ' + this.fromRect.width + 'px; height: ' + this.fromRect.height + 'px;'

        setTimeout(() => {
          this.$refs.globalWheel.$el.style.cssText = 'visibility: visible; z-index: 999999; position: absolute; top: ' + this.fromRect.top + 'px; left: ' + this.fromRect.left + 'px; width: ' + this.fromRect.width + 'px; height: ' + this.fromRect.height + 'px; transform: translate(' + (toCenter.centerX - fromCenter.centerX) + 'px, ' + (toCenter.centerY - fromCenter.centerY) + 'px) scale(' + (toRect.width / this.fromRect.width) + ', ' + (toRect.height / this.fromRect.height) + '); transition: all 1.3s ease;'
        }, 100)
      } else {
        this.setWheelVisible(true)
      }
    },
    getOffset (el) {
      let rect = el.getBoundingClientRect()
      let x = 0
      let y = 0

      while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
        x += el.offsetLeft - el.scrollLeft
        y += el.offsetTop - el.scrollTop
        el = el.offsetParent
      }

      rect.x = x
      rect.y = y
      return rect
    }
  },
  mounted () {
    this.states.push({ name: 'landing', wheel: this.$refs.landing.$refs.landingWheel })
    this.states.push({ name: 'project', wheel: this.$refs.project.$refs.modalProject.$refs.modalWheel })
    this.states.push({ name: 'goals', wheel: this.$refs.goals.$refs.goalWheel })
    this.states.push({ name: 'targets', wheel: this.$refs.targets.$refs.targetWheel })
    this.states.push({ name: 'results', wheel: null })

    this.$refs.globalWheel.$el.addEventListener('transitionend', () => {
      this.setWheelVisible(true)

      setTimeout(() => {
        this.showGlobalWheel = false
      }, 10)
    })
  }
}
</script>
